import { Page, PageHeader } from '../../shared/ui/layout';
import {
  NotificationDigestBody,
  NotificationDigestHeader,
  useNotificationDigest,
} from '../../features/notification-feed';
import { useSession } from '../../entities/session';

// The bell's panel, for a link from an email: the same lines, nothing the panel does not show.
export const NotificationsPage = () => {
  const session = useSession();
  const state = useNotificationDigest();

  return (
    <>
      <PageHeader
        title="Notifications"
        description="What needs you now, and what only happened. The last 30 days."
      />
      <Page>
        <div className="max-w-form overflow-hidden rounded-panel border border-border-raised bg-surface-raised">
          <NotificationDigestHeader state={state} />
          <NotificationDigestBody state={state} timeZone={session.data?.preferences.timezone} />
        </div>
      </Page>
    </>
  );
};
